import { Link } from "@inertiajs/react"
import type { TttAuthorSummary } from "@/components/ttt/types"

interface AuthorCardProps {
  author: TttAuthorSummary
}

// Faithful port of app/views/ttt/authors/_authors_grid.html.slim: the avatar
// tilts on hover while the name box slides up over it and fills dark.
export default function AuthorCard({ author }: AuthorCardProps) {
  return (
    <Link href={author.url} className="relative group block">
      <div className="flex flex-col items-center border border-primary rounded-lg overflow-hidden transition-all duration-300 group-hover:rotate-6">
        {author.avatar_url ? (
          <img
            src={author.avatar_url}
            alt={author.nickname}
            loading="lazy"
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full aspect-square bg-light flex items-center justify-center text-primary">
            <i className="fa-solid fa-user text-3xl" />
          </div>
        )}
      </div>
      <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 w-3/4 uppercase bg-light px-2 py-2 rounded-lg border border-primary text-center text-primary transition-all duration-300 group-hover:-translate-y-44 group-hover:text-light group-hover:bg-content group-hover:border-none">
        {author.nickname}
      </div>
    </Link>
  )
}
